import { render, staticRenderFns } from "./NewsletterBlock.vue?vue&type=template&id=d6fe3114&"
import script from "./NewsletterBlock.vue?vue&type=script&lang=js&"
export * from "./NewsletterBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports